document.addEventListener('DOMContentLoaded', function() {
  const productAccordions = document.querySelectorAll('.product__info-container .accordion details');
  
  productAccordions.forEach(function(details) {
    details.addEventListener('toggle', function() {
      const summary = this.querySelector('summary');
      
      if (this.open) {
        summary.setAttribute('aria-expanded', 'true');
        productAccordions.forEach(function(otherDetails) {
          if (otherDetails !== details && otherDetails.open) {
            otherDetails.open = false;
            otherDetails.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
      } else {
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  });
});